import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { getLabel } from 'utils/getLabel';
import { MemberOrderDetailSummary } from 'ui/containers/MemberOrderDetailSummary';
import { OrderDetailsPrescriptions } from 'ui/containers/OrderDetailsPrescriptions';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.ORDER_DETAILS_SUMMARY ]: MemberOrderDetailSummary,
    [ WIDGET_NAMES.ORDER_DETAILS_RX ]: OrderDetailsPrescriptions,
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberOrderDetail as MemberOrderDetail } from 'ui/views/widgets/memberOrderDetail';
 *
 * // render
 * <MemberOrderDetail propName='propValue'/>
 */
const _memberOrderDetail = ( props ) => {

    return (
        <div className='ui-memeber-order-detail'>

            <div className='ui-memeber-order-detail__action'>
                {
                    map( props.navActions, navAction => {

                        // get the action for navAction
                        const icondId = 'back' === navAction.name ? 'backArrow': null;

                        return (
                            <div className='ui-memeber-order-detail__action__navaction' key={ navAction.name }
                                onClick={ () => props.onNavActionClick( { type: 'headerAction', value: navAction } ) }
                            >
                                <Icon id={ icondId } />
                                <div className='ui-memeber-order-detail__action__navaction__label'>{ getLabel( navAction.title ) }</div>
                            </div>
                        );

                    } )
                }
            </div>

            {/* widget sequence view */}
            <div className='ui-memeber-order-detail__widgets'>
                {
                    map( props.widgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        // widget class name
                        const widgetClassName = classnames( 'ui-memeber-order-detail__widgets__widget' );

                        return (
                            <div key={ widget.name } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    memberId={ props.memberId }
                                    onDependentSwitch={ props.onDependentSwitch }
                                    requestPayload={ props.requestPayload }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>
            
        </div>
    );
};

// set display name
_memberOrderDetail.displayName = 'memberOrderDetail';

// set default props
_memberOrderDetail.defaultProps = {};

// prop types
_memberOrderDetail.propTypes = {};

// preloader view
export const memberOrderDetailsWidgetPreloader = () => {
    return (
        <div className='ui-member-details-widget-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
memberOrderDetailsWidgetPreloader.displayName = 'memberOrderDetailsWidgetPreloader';

// set default props
memberOrderDetailsWidgetPreloader.defaultProps = {};

// prop types
memberOrderDetailsWidgetPreloader.propTypes = {};

export const memberOrderDetail = withNetworkState( memberOrderDetailsWidgetPreloader, _memberOrderDetail );
